const defaultState = {
  data: [],
  loading: false,
  error: false,
};

/*
    Due to the sensitive nature of permissions, only track loading and error in redux,
    since we have it configured to persist.
 */
const permissions = function (state = defaultState, action) {
  let data, target;

  switch (action.type) {
    case 'SET_GROUPS_LOADING':
      return {
        ...state,
        groups_loading: action.data,
      };

    case 'SET_GROUPS_ERROR':
      return {
        ...state,
        groups_error: action.data,
      };

    case 'SET_GROUPS':
      let groups = action.data.filter((item) => item.name.indexOf('inactive') === -1);
      return {
        ...state,
        groups,
      };

    case 'SET_ADMIN_STATUS':
      let is_admin = false;
      action.data.forEach((item) => {
        if (item.name.match(/(admin|root)/)) {
          is_admin = true;
        }
      });

      return {
        ...state,
        is_admin,
      };

    case 'SET_USER_GROUPS_LOADING':
      return {
        ...state,
        usergroups_loading: action.data,
      };

    case 'SET_USER_GROUPS_ERROR':
      return {
        ...state,
        usergroups_error: action.data,
      };

    default:
      return state;
  }
};

export default permissions;
